<template>
    <div class="mt-6">
        <div class="loading-spinner-outer" v-if="loading_tenders">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading Tenders, this can take a few minutes, please wait
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="tender-portal-types" v-show="system_types.length > 1">
                <label v-for="system_type in system_types"
                       class="mr-2"
                       :class="{ 'btn-primary' : selected_portal_id === system_type.id, 'btn-link' : selected_portal_id !== system_type.id }"
                       v-if="system_type.id === 2 || system_type.id === 5"
                >{{ system_type.label }} <input type="radio" name="selected_system_type_id" v-model="selected_portal_id" :value="system_type.id" class="hide"> </label>
            </div>
            <div class="tender-portal-types">
              <label class="mr-2"
                     :class="{ 'btn-primary' : active_section === 'active_tenders', 'btn-link' : active_section !== 'active_tenders' }"
              >Active Tenders<input type="radio" v-model="active_section" :value="'active_tenders'" class="hide"> </label>
              <label class="mr-2"
                     :class="{ 'btn-primary' : active_section === 'archived_tenders', 'btn-link' : active_section !== 'archived_tenders' }"
              >Archived Tenders<input type="radio" v-model="active_section" :value="'archived_tenders'" class="hide"> </label>
            </div>
            <template v-if="!loading_tenders && filtered_tenders.length > 0">
                <div class="black-ice-tenders-list">
                    <a :href="`/commercial/tender-downloads/detail/${tender.TenderID}`" v-for="tender in filtered_tenders" class="black-ice-tenders-list-item">
                        <div class="top-row">
                            <div class="status-marker" v-if="isNew(tender.EnteredDate)">New</div>
                            <div class="status-marker" v-if="expired(tender.DeadlineDate)">Expired</div>
                            <div class="status-marker" v-if="expiresSoon(tender.DeadlineDate)">Expiring Soon</div>
                            <div class="left">
                                <div class="row-item">
                                    <div>
                                        <strong>
                                            Tender Name:
                                        </strong>
                                        <span>
                                            {{ tender.TenderName }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row-item">
                                    <div>
                                        <strong>
                                            Client Name:
                                        </strong>
                                        <span>
                                                {{ tender.ClientName }}
                                            </span>
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="row-item">
                                    <div>
                                        <strong>
                                            Entered Date:
                                        </strong>
                                        <span>
                                                {{ tender.EnteredDate }}
                                            </span>
                                    </div>
                                </div>
                                <div class="row-item">
                                    <div>
                                        <strong>
                                            Deadline Date:
                                        </strong>
                                        <span>
                                                {{ tender.DeadlineDate }}
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </template>
            <template v-if="!loading_tenders && filtered_tenders.length === 0">
                <strong>
                    No Tenders Found
                </strong>
            </template>
        </div>
    </div>
</template>

<script>

  export default {
    props: [
      'system_types',
    ],
    data() {
      return {
        active_section: 'active_tenders',
        active_tenders: [],
        archived_tenders: [],
        // current_page: 1,
        // total_count: 0,
        // total_pages: 0,
        portal: 'profile22',
        // limit: 20,
        loading_tenders: true,
        selected_portal_id: 2,
      };
    },
    mounted() {
      this.selected_portal_id = this.system_types[0].id,
      this.loadTenders();
    },
    methods: {
      loadTenders() {
        this.loading_tenders = true;
        axios.post('/commercial/black-ice-api/getTenders', {
          // page_number: this.current_page,
          // limit: this.limit,
          selected_portal_id: this.selected_portal_id,
          // portal_user_id: 75932,
        }).then((response) => {
          this.active_tenders = response.data.active_tenders;
          this.archived_tenders = response.data.archived_tenders;

          gtag('event', 'tender_list_viewed', {
            'event_category': 'commercial_tenders',
            'event_label': 'Tender list viewed',
            'value': 'Tender list viewed',
          });

          // this.total_count = response.data.total;
          // this.total_pages = response.data.last_page;
          this.loading_tenders = false;
        });
      },
      // prevPage() {
      //   this.current_page = this.current_page - 1;
      //   this.loadTenders();
      // },
      // nextPage() {
      //   this.current_page = this.current_page + 1;
      //   this.loadTenders();
      // }
      isNew(date) {
        const inputDate = new Date(date);
        const currentDate = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(currentDate.getDate() - 7);
        return inputDate >= oneWeekAgo;
      },
      expiresSoon(date) {
        const inputDate = new Date(date);
        const currentDate = new Date();
        const oneWeekFromNow = new Date();
        oneWeekFromNow.setDate(currentDate.getDate() + 7);
        return inputDate > currentDate && inputDate <= oneWeekFromNow;
      },
      expired(date) {
        const inputDate = new Date(date);
        const currentDate = new Date();
        return inputDate <= currentDate;
      },
    },
    computed: {
      filtered_tenders() {
        return this[this.active_section];
      },
    },
    watch: {
      portal() {
        // this.current_page = 1;
        this.loadTenders();
      },
      selected_portal_id() {
        if(this.selected_portal_id === 2) {
          this.portal = 'profile22';
        }
        if(this.selected_portal_id === 5) {
          this.portal = 'spectus';
        }
      },
    },
  };
</script>
